var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[(_vm.show)?_c('communicationgroup'):_c('noticecomponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }